<template>
	<div class="homeInfo">
		<div class="homeInfo-banner">
			<div class="info_location">
				<!-- <div class="info_location_img">
          <img src="./../../../assets/location1.png" />
        </div>-->
				<div class="info_location_text">
					<!-- <span>当前位置：</span> -->
					<span>首页</span>
					<span>></span>
					<span>权责列表</span>
				</div>
			</div>
			<div class="homeInfo-title">
				<!-- <p>{{ title }}</p> -->
				<div class="homeInfo-title-box">
					<div class="homeInfo-title-headr">
						<p>{{ affair.Name }}</p>
					</div>
					<div class="homeInfo-title-code">
						<p>职权编码：{{ affair.Code }}</p>
					</div>
					<div class="homeInfo-title-content">
						<p>职权类别：{{ affair.AffairTypeName }}</p>
						<p>实施主体：{{ affair.UnitName }}</p>
						<p>访问量：{{ affair.ClickNum }}</p>
						<!-- <p>承诺时限：{{affair.PromiseDay}}{{affair.PromiseDayType | DayTypeFilter}}</p>
            <p>监督电话：{{affair.ControlPhone | phoneFilter}}</p>
            <p>投诉电话：{{affair.ServicePhone | phoneFilter}}</p>-->
					</div>
				</div>
			</div>
		</div>

		<div class="homeInfo-box">
			<div class="homeInfo-content-box">
				<!--<div class="content-menuList">
          <ul>
            <li>
              <a
                href="javascript:void(0)"
                :class="{ active: current == 1 }"
                @click="setCurrent('权责清单', 1)"
              >权责清单</a>
            </li>
            <li>
              <a
                href="javascript:void(0)"
                :class="{ active: current == 2 }"
                @click="setCurrent('设立依据', 2)"
              >设立依据</a>
            </li>
            <li>
              <a
                href="javascript:void(0)"
                :class="{ active: current == 2 }"
                @click="setCurrent('流程图', 2)"
              >流程图</a>
            </li>
            <li>
              <a
                href="javascript:void(0)"
                :class="{ active: current == 2 }"
                @click="setCurrent('办事指南', 2)"
              >办事指南</a>
            </li>
           <li>
              <a
                href="javascript:void(0)"
                :class="{ active: current == 4 }"
                @click="setCurrent('附件下载', 4)"
              >附件下载</a>
            </li>
            <li>
              <a
                href="javascript:void(0)"
                :class="{ active: current == 3}"
                @click="setCurrent('业务手册', 3)"
              >业务手册</a>
            </li>
            <li>
              <a
                href="javascript:void(0)"
                :class="{ active: current == 4 }"
                @click="setCurrent('意见建议', 4)"
              >意见建议</a>
            </li>
          </ul>
        </div>-->
				<div class="content-menuText">
					<p>{{ menuText }}</p>
				</div>
				<div class="content-boxList" ref="boxlist">
					<div
						class="list-transiton"
						:style="{ left: '-' + (current - 1) * 1200 + 'px' }"
					>
						<div class="list-box">
							<tableFirst
								:affair="affair"
								:dutyList="dutyList"
								:feeList="feeList"
								:slyjList="slyjList"
							></tableFirst>
						</div>
						<!-- <div class="list-box">
              <tableTwo :slyjList="slyjList"></tableTwo>
            </div>-->
						<!-- <div class="list-box">
              <tableThree :imgUrl="imgUrl"></tableThree>
            </div>-->
						<div class="list-box">暂无内容</div>
						<!-- <div class="list-box">
              <tableFive :fileUpload="fileUpload"></tableFive>
            </div>-->
						<div class="list-box">暂无内容</div>
						<div class="list-box">
							<tableFour :affairId="Number(this.$route.query.id)"></tableFour>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import tableFirst from "@/components/infos/tableFirst.vue";
	// import tableTwo from "@/components/infos/tableTwo.vue";
	// import tableThree from "@/components/infos/tableThree.vue";
	import tableFour from "@/components/infos/tableFour.vue";
	// import tableFive from "@/components/infos/tableFive.vue";
	export default {
		data() {
			return {
				title: "行政权责基本信息表",
				current: 1,
				slyjList: [],
				// imgUrl: "",
				// fileUpload: {},
				affair: {},
				dutyList: [],
				feeList: [],
				menuText: "权责清单",
			};
		},
		components: {
			tableFirst,
			tableFour,
			// tableTwo,
			// tableThree,
			// tableFive
		},
		mounted() {
			this.initTableForm();
		},
		methods: {
			setCurrent(name, id) {
				this.menuText = name;
				this.current = id;
			},
			initTableForm() {
				this.$axios({
					url: "api/getDetailById/" + this.$route.query.id,
					type: "get",
				})
					.then((res) => {
			res.data.affair.XSCJTypeNames=res.data.affair.XSCJTypeNames.replace('县级','县（市）级')
						console.log(res,"连接连接");
						this.affair = res.data.affair;
						this.dutyList = res.data.dutyList;
						this.feeList = res.data.feeList;
						this.slyjList = res.data.slyjList;
						// this.imgUrl = res.data.imgUrl;
						// this.fileUpload = res.data.fileUpload;
					})
					.catch((err) => {
						console.info(err);
					});
			},
		},
		filters: {
			DayTypeFilter: function(value) {
				if (value == 1) {
					return "个工作日";
				} else if (value == 2) {
					return "日";
				} else if (value == 3) {
					return "个月";
				} else if (value == 4) {
					return "年";
				}
			},
			phoneFilter: function(value) {
				if (!!value && value.trim().indexOf("0373") == 0) {
					return value;
				} else {
					return "0373-" + value;
				}
			},
		},
	};
</script>

<style lang="scss" scoped>
	.homeInfo {
		width: 100%;
		height: auto;
		// background: linear-gradient(360deg, #ffffff, transparent);
		// padding: 20px;
		position: relative;
		// box-shadow: 0 0 10px #000000;
		// border-radius: 10px;

		.homeInfo-banner {
			width: 100%;
			height: auto;
			background-image: url("./../../../assets/bkList.png");
			background-repeat: no-repeat;
			background-position: center center;
			background-size: 100% 100%;
			position: relative;
			padding: 10px 0;
			.homeInfo-title {
				width: 1200px;
				height: auto;
				left: 0;
				right: 0;
				margin: auto;
				.homeInfo-title-box {
					width: 100%;
					height: auto;
					// padding: 10px 10px 30px 10px;
					// background-color: #3dc1d3;
					.homeInfo-title-headr {
						width: 100%;
						// height: 55px;
						p {
							line-height: 40px;
							text-align: left;
							letter-spacing: 2px;
							font-size: 30px;
							font-family: Microsoft YaHei;
							font-weight: bold;
							color: #ffffff;
							// color: #c40202;
							// color: #3dc1d3;
						}
					}
					.homeInfo-title-code {
						width: 100%;
						height: 40px;
						p {
							width: 100%;
							height: 40px;
							line-height: 30px;
							font-size: 16px;
							font-family: Microsoft YaHei;
							font-weight: 400;
							color: #ffffff;
							text-align: left;
						}
					}
					.homeInfo-title-content {
						width: 100%;
						height: 70px;
						background-color: #ffffff;
						display: flex;
						justify-content: space-evenly;
						align-items: center;
						padding: 10px;
						p {
							width: 100%;
							padding: 0 15px;
							font-size: 18px;
							font-family: Microsoft YaHei;
							font-weight: 400;
							color: #666666;
							&:nth-of-type(2) {
								border-right: 1px solid #e22519;
								border-left: 1px solid #e22519;
							}
							// &:nth-of-type(3) {
							//   border-right: 1px solid #e22519;
							// }
						}
					}
				}
			}
		}
		.homeInfo-box {
			width: 1200px;
			height: auto;
			left: 0;
			right: 0;
			margin: auto;
			.homeInfo-content-box {
				width: 100%;
				height: auto;
				position: relative;
				.content-menuList {
					position: position;
					width: 100%;
					height: 55px;
					ul {
						width: 100%;
						height: 55px;
						li {
							float: left;
							width: auto;
							height: 55px;
							list-style: none;
							padding: 0 5px;
							a {
								padding: 10px 20px;
								line-height: 55px;
								text-align: center;
								// background: linear-gradient(135deg, #0fbcf9, #3dc1d3);
								color: #666666;
								font-size: 16px;
								font-family: Microsoft YaHei;
								font-weight: 400;
								text-decoration: none;
								&.active {
									// background: linear-gradient(
									//   135deg,
									//   #e66767,
									//   #f19066,
									//   transparent
									// );
									// background: linear-gradient(135deg, #22a6b3, #2f80ed);
									color: #cd0600;
									border-bottom: 2px solid #e22519;
								}
							}
						}
					}
				}
				.content-menuText {
					width: 100%;
					height: 50px;
					position: relative;
					&:after {
						content: "";
						width: 8px;
						height: 20px;
						border-radius: 4px;
						background: #e22519;
						position: absolute;
						top: 0;
						bottom: 0;
						left: 0;
						margin: auto;
						z-index: 50;
					}
					p {
						width: 100%;
						height: 50px;
						line-height: 50px;
						font-size: 18px;
						font-family: Microsoft YaHei;
						font-weight: 400;
						color: #333333;
						text-align: left;
						padding-left: 20px;
					}
				}
				.content-boxList {
					width: 100%;
					height: auto;
					padding: 10px 0px;
					position: relative;
					overflow: hidden;
					.list-transiton {
						min-width: 100%;
						width: auto;
						display: flex;
						transition: 1s;
						justify-content: flex-start;
						position: relative;
						.list-box {
							min-width: 100%;
							// border: 1px solid #ebebeb;
							height: 100%;
							float: left;
							font-size: 14px;
							font-family: Microsoft YaHei;
							font-weight: 400;
							color: #333333;
						}
					}
				}
			}
		}
	}
	.fade-enter-active {
		animation: fade-in 0.5s;
		animation-fill-mode: both;
	}
	.fade-leave-active {
		animation: fade-in 0.5s reverse;
		animation-fill-mode: both;
	}
	@keyframes fade-in {
		0% {
			opacity: 0;
		}
		100% {
			height: 30px;
			opacity: 1;
		}
	}
</style>
